import { getCountry } from "./getCountry";

export const formatAddress = ({
  addressLine1,
  addressLine2,
  zip,
  city,
  country,
}: {
  addressLine1: string;
  addressLine2?: string;
  city: string;
  zip: string;
  country: string;
}) => {
  const mappedCountry = getCountry(country);

  return {
    country: mappedCountry,
    address: `${addressLine1}${
      addressLine2 ? ` ${addressLine2}` : ""
    }, ${zip} ${city}`,
  };
};
